import { Mutation, MutationTree } from 'vuex'
import { State } from './state'
import { CurrentUser } from "@/pitprojekt/models/CurrentUser";
import { EventBus } from "@/pitprojekt/event-bus";
import moment from 'moment';

export function gettingSettings(state: State) {
    state.allSettingsComplete = false;
    state.gettingSettings = true;
}

export function currentUser(state: State, currentUser:CurrentUser) {
    state.currentUser = currentUser
}

export function cleanSettings(state: State) {
    state.allSettingsComplete = false;
    state.gettingSettings = false;
    state.currentUser = new CurrentUser();
}

export function settingsComplete(state: State) {
    state.allSettingsComplete = true;
    state.gettingSettings = false;
}

export function changeDateFrom(state: State, date: string) {
    state.dateFrom = date;
    EventBus.$emit('PageTitleDateChangedEvent');
}

export function changeDateTo(state: State, date: string) {
    state.dateTo = date;
    EventBus.$emit('PageTitleDateChangedEvent');
}

export function changeSelectedProducts(state: State, selectedProducts: Array<number>) {
    state.selectedProducts = selectedProducts;
}

export function changeSelectedProduct(state: State, selectedProduct: number) {
    state.selectedProduct = selectedProduct;
}

export function changeFilterProductsToPitOnly(state: State, filterProductsToPitOnly: boolean) {
    state.filterProductsToPitOnly = filterProductsToPitOnly;
}

export function changeOnlyOneProductAvailable(state: State, onlyOneProductAvailable: boolean) {
    state.onlyOneProductAvailable = onlyOneProductAvailable;
}

export function setDefaultSelectedProduct(state: State, products: Array<number>) {
    state.selectedProducts = products;
}

export function changeLastYear(state: State, lastYear: boolean) {
    state.lastYear = lastYear;

    //If change is to lastYear,
    if (lastYear) {
        //If date range is current year -> update date to last year
        if (moment(state.dateFrom).isSame(new Date(), 'year') || moment(state.dateTo).isSame(new Date(), 'year')) {
            state.dateFrom = moment(state.dateFrom).subtract(1, 'years').format('YYYY-MM-DD');
            state.dateTo = moment(state.dateTo).subtract(1, 'years').format('YYYY-MM-DD');
        }
        //if not -> set  last year default dates
        else {
            state.dateFrom = moment().subtract(1, 'years').subtract(1, 'months').toISOString().substr(0, 10);
            state.dateTo = moment().subtract(1, 'years').toISOString().substr(0, 10);
        }
    }

    //If change is to currentYear
    if (!lastYear) {
        //If date range is last year -> update to current year
        if (moment(state.dateFrom).isSame(moment().subtract(1, 'years'), 'year') || moment().isSame(moment(state.dateTo).subtract(1, 'years'), 'year')) {
            state.dateFrom = moment(state.dateFrom).add(1, 'years').format('YYYY-MM-DD');
            state.dateTo = moment(state.dateTo).add(1, 'years').format('YYYY-MM-DD');
        }
        //if not -> set default dates
        else {
            state.dateFrom = moment().subtract(1, 'months').toISOString().substr(0, 10);
            state.dateTo = moment().toISOString().substr(0, 10);
        }
    }
    EventBus.$emit('PageTitleDateChangedEvent');
}

export default <MutationTree<State>> {
    currentUser,
    cleanSettings,
    gettingSettings,
    settingsComplete,
    changeDateFrom,
    changeDateTo,
    changeSelectedProducts,
    changeSelectedProduct,
    changeFilterProductsToPitOnly,
    changeOnlyOneProductAvailable,
    setDefaultSelectedProduct,
    changeLastYear
}
